module.exports = __webpack_public_path__ + "static/woman-drinking-coffee-and-looking-out-the-window-reversed.f5ad2212.webp";